import generalStrings from 'modules/general/strings';

export const businessIndustryList = [
  {
    key: 'Technology',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryTechnologyRadioButtonText,
  },
  {
    key: 'Medical',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryMedicalRadioButtonText,
  },
  {
    key: 'Transportation',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryTransportationRadioButtonText,
  },
  {
    key: 'Groceries',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryGroceriesRadioButtonText,
  },
  {
    key: 'Food & drink',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryFoodRadioButtonText,
  },
  {
    key: 'Restaurants',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryRestaurantsRadioButtonText,
  },
  {
    key: 'Sports',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustrySportsRadioButtonText,
  },
  {
    key: 'Furniture',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryFurnitureRadioButtonText,
  },
  {
    key: 'Tourism service',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryTourismRadioButtonText,
  },
  {
    key: 'Clothing',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryClothingRadioButtonText,
  },
  {
    key: 'Beauty',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryBeautyRadioButtonText,
  },
  {
    key: 'Other',
    name: generalStrings.registerForm.businessIndustryRadioButtons
      .businessIndustryOtherRadioButtonText,
  },
];

export const userPositionList = [
  {
    key: 'Business owner',
    name: generalStrings.registerForm.userPositionRadioButtons
      .userPositionBusinessOwnerRadioButtonText,
  },
  {
    key: 'HR manager',
    name: generalStrings.registerForm.userPositionRadioButtons.userPositionHrManagerRadioButtonText,
  },
  {
    key: 'Company doctor',
    name: generalStrings.registerForm.userPositionRadioButtons
      .userPositionCompanyDoctorRadioButtonText,
  },
  {
    key: 'Employee',
    name: generalStrings.registerForm.userPositionRadioButtons.userPositionEmployeeRadioButtonText,
  },
  {
    key: 'Health manager',
    name: generalStrings.registerForm.userPositionRadioButtons
      .userPositionHealthManagerRadioButtonText,
  },
  {
    key: 'Other',
    name: generalStrings.registerForm.userPositionRadioButtons.userPositionOtherRadioButtonText,
  },
];
